import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { findTicket } from '../../Api';


const Winner = ({ reward, marketplace }) => {
    return <div className="box-body box-profile">
        <img src={'/assets/ganador.jpeg'} alt='Ganador' className="img-responsive" />
        <h3 className="profile-username text-center">Eres un ganador</h3>
        <ul className="list-group list-group-unbordered">
            <li className="list-group-item">
                <b>Valor</b>
                <span clspanassName="pull-right">{reward.value}</span>
            </li>
            <li className="list-group-item">
                <b>Plaza</b> <span className="pull-right">{marketplace.name}</span>
            </li>
        </ul>
    </div>
}

const Jackpot = ({ marketplace }) => {
    return <div className="box-body box-profile">
        <img src={'/assets/ganador.jpeg'} alt='Ganador' className="img-responsive" />
        <h3 className="profile-username text-center">Eres un ganador</h3>
        <ul className="list-group list-group-unbordered">
            <h1>Premio mayor</h1>
            <li className="list-group-item">
                <b>Plaza</b> <span className="pull-right">{marketplace.name}</span>
            </li>
        </ul>
    </div>
}

const Loser = ({ scam = null }) => {
    return <div className="box-body box-profile">
        <img src={'/assets/otrodia.jpeg'} alt='Ganador' className="img-responsive" />
        <h3 className="profile-username text-center">Buena suerte para la proxima</h3>
        {scam && (<h3 className="profile-username text-center">Boleto no es valido</h3>)}
    </div>
}

class CheckForm extends Component {
    state = {
        data: {},
        errors: {}
    };

    async componentDidMount() {
        const hasParams = this.props.match && this.props.match.params
        if (hasParams) {
            const { code } = this.props.match.params;
            let data = await findTicket({
                token: '',
                params: { code }
            })
            this.setState({ data })
        }
    }

    clearErrorState = () => {
        this.setState({
            errors: {
                cognito: null,
                blankfield: false
            }
        });
    };

    render() {
        let content = <Loser {...this.state.data} />
        if (this.state.data.winner) {
            content = <Jackpot {...this.state.data} />
        } else if (this.state.data.reward) {
            content = <Winner {...this.state.data} />
        }
        return (
            <section className="">
                <div className="container">
                    {content}
                </div>
            </section>
        );
    }
}

const mapStoreToProps = (state, ownProps) => {
    return { ...ownProps }
}
export default withRouter(connect(mapStoreToProps)(CheckForm));